import { useState, useRef } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const honeypotRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Honeypot check
    if (honeypotRef.current?.value?.trim()) {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email || !email.includes('@')) {
      setStatus('error');
      return;
    }

    setStatus('success');
    setEmail('');
  };

  return (
    <section className="w-full py-10 md:py-16 px-4 md:px-6 lg:px-8">
      <div className="w-full max-w-4xl mx-auto text-center bg-background-100 rounded-2xl md:rounded-3xl p-8 md:p-12">
        <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-background-200 flex items-center justify-center">
          <i className="ri-mail-send-line text-2xl text-primary-500" />
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2">
          Stay in the Loop
        </h2>
        <p className="text-base text-foreground-600 mb-6 md:mb-8 max-w-lg mx-auto">
          Subscribe to get exclusive deals, new arrival alerts, and special offers delivered straight to your inbox.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto" data-readdy-form>
          {/* Honeypot */}
          <input
            ref={honeypotRef}
            type="text"
            name="company_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            className="hp-field"
          />

          <div className="flex-1 relative">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }}
              placeholder="Enter your email address"
              required
              className="w-full h-12 pl-4 pr-4 rounded-full bg-background-50 border border-background-200/70 text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition-all"
            />
          </div>
          <button
            type="submit"
            className="h-12 px-8 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/25 whitespace-nowrap flex items-center justify-center gap-2"
          >
            Subscribe
            <i className="ri-arrow-right-line" />
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-foreground-900 font-medium flex items-center justify-center gap-1.5">
            <i className="ri-checkbox-circle-line" />
            You are subscribed! Check your inbox for a welcome offer.
          </p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-foreground-900 font-medium flex items-center justify-center gap-1.5">
            <i className="ri-error-warning-line" />
            Please enter a valid email address.
          </p>
        )}

        <p className="mt-4 text-xs text-foreground-500">
          By subscribing, you agree to our Privacy Policy. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
}